import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

// Irish provinces and their counties
const PROVINCES: Record<string, { slug: string; name: string }[]> = {
  Leinster: [
    { slug: "carlow", name: "Carlow" },
    { slug: "dublin", name: "Dublin" },
    { slug: "kildare", name: "Kildare" },
    { slug: "kilkenny", name: "Kilkenny" },
    { slug: "laois", name: "Laois" },
    { slug: "longford", name: "Longford" },
    { slug: "louth", name: "Louth" },
    { slug: "meath", name: "Meath" },
    { slug: "offaly", name: "Offaly" },
    { slug: "westmeath", name: "Westmeath" },
    { slug: "wexford", name: "Wexford" },
    { slug: "wicklow", name: "Wicklow" },
  ],
  Munster: [
    { slug: "clare", name: "Clare" },
    { slug: "cork", name: "Cork" },
    { slug: "kerry", name: "Kerry" },
    { slug: "limerick", name: "Limerick" },
    { slug: "tipperary", name: "Tipperary" },
    { slug: "waterford", name: "Waterford" },
  ],
  Connacht: [
    { slug: "galway", name: "Galway" },
    { slug: "leitrim", name: "Leitrim" },
    { slug: "mayo", name: "Mayo" },
    { slug: "roscommon", name: "Roscommon" },
    { slug: "sligo", name: "Sligo" },
  ],
  Ulster: [
    { slug: "cavan", name: "Cavan" },
    { slug: "donegal", name: "Donegal" },
    { slug: "monaghan", name: "Monaghan" },
  ],
};

function getProvinceForCounty(countySlug: string): string | null {
  for (const [province, counties] of Object.entries(PROVINCES)) {
    if (counties.some((c) => c.slug === countySlug.toLowerCase())) {
      return province;
    }
  }
  return null;
}

interface CountyProvinceLinksProps {
  currentCountySlug: string;
  currentCountyName: string;
}

export function CountyProvinceLinks({ currentCountySlug, currentCountyName }: CountyProvinceLinksProps) {
  const province = getProvinceForCounty(currentCountySlug);
  if (!province) return null;

  const siblingCounties = PROVINCES[province].filter(
    (c) => c.slug !== currentCountySlug.toLowerCase()
  );

  return (
    <div className="rounded-xl border border-border bg-card p-6">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-semibold text-foreground">
          Other {province} Counties
        </h2>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Browse nursing homes in other {province} counties near {currentCountyName}.
      </p>
      <div className="flex flex-wrap gap-2">
        {siblingCounties.map((county) => (
          <Link
            key={county.slug}
            to={`/nursing-homes/${county.slug}`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
          >
            {county.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
